import { createBrowserRouter, Outlet } from 'react-router-dom'
import { AppShell } from './components/layout/AppShell'
import { NotFound } from './pages/NotFound'
import AuthGuard from './components/features/AuthGuard'
import ConsultantGuard from './components/features/ConsultantGuard'
import AdminLayout from './pages/Admin/layout'

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      {
        path: '/',
        lazy: () => import('./pages/Home').then((m) => ({ Component: m.Home })),
      },
      {
        path: '/releases',
        lazy: () => import('./pages/Releases').then((m) => ({ Component: m.Releases })),
      },
      {
        path: '/releases/:slug',
        lazy: () => import('./pages/Releases/ReleaseDetail').then((m) => ({ Component: m.ReleaseDetail })),
      },
      {
        path: '/links',
        lazy: () => import('./pages/Links').then((m) => ({ Component: m.Links })),
      },
      {
        path: '/press',
        lazy: () => import('./pages/Press').then((m) => ({ Component: m.Press })),
      },
      {
        path: '/signal',
        lazy: () => import('./pages/Signal').then((m) => ({ Component: m.Signal })),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  // Admin routes (protected by AuthGuard)
  {
    path: '/admin',
    element: (
      <AuthGuard requiredRole="Admin">
        <AdminLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        lazy: () => import('./pages/Admin/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'releases',
        lazy: () => import('./pages/Admin/Releases/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'links',
        lazy: () => import('./pages/Admin/Links/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'press',
        lazy: () => import('./pages/Admin/Press/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'settings',
        lazy: () => import('./pages/Admin/Settings/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'signal',
        lazy: () => import('./pages/Admin/Signal/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'users',
        lazy: () => import('./pages/Admin/Users/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'users/invite',
        lazy: () => import('./pages/Admin/Users/InviteForm').then((m) => ({ Component: m.default })),
      },
      {
        path: 'users/:userId',
        lazy: () => import('./pages/Admin/Users/UserDetail').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums',
        lazy: () => import('./pages/Admin/Albums/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'catalog',
        lazy: () => import('./pages/Admin/Catalog/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'catalog/:trackId',
        lazy: () => import('./pages/Admin/Catalog/SongDetail').then((m) => ({ Component: m.default })),
      },
      {
        path: 'library',
        lazy: () => import('./pages/Admin/Library/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'characters',
        lazy: () => import('./pages/Admin/Characters/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'characters/:characterId',
        lazy: () => import('./pages/Admin/Characters/index').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId',
        lazy: () => import('./pages/Admin/Albums/AlbumDetail').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/export',
        lazy: () => import('./pages/Admin/Albums/AlbumExport').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/arc',
        lazy: () => import('./pages/Admin/Albums/AlbumArcStudio').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/tracks/:trackId',
        lazy: () => import('./pages/Admin/Tracks/TrackDetail').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/tracks/:trackId/compose',
        lazy: () => import('./pages/Admin/Tracks/ComposeStudio').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/tracks/:trackId/renditions',
        lazy: () => import('./pages/Admin/Tracks/RenditionsStudio').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/tracks/:trackId/music-video',
        lazy: () => import('./pages/Admin/Tracks/MusicVideoStudio').then((m) => ({ Component: m.default })),
      },
      {
        path: 'exports/:id',
        lazy: () => import('./pages/Admin/Exports/ExportDetail').then((m) => ({ Component: m.default })),
      },
    ],
  },
  {
    path: '/lineage/:assetId',
    element: (
      <AuthGuard requiredRole="Admin">
        <Outlet />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        lazy: () => import('./pages/Admin/Lineage/LineageDetail').then((m) => ({ Component: m.default })),
      },
    ],
  },
  // Consultant routes (protected by ConsultantGuard)
  {
    path: '/consultant',
    element: (
      <ConsultantGuard>
        <Outlet />
      </ConsultantGuard>
    ),
    children: [
      {
        path: 'albums',
        lazy: () => import('./pages/Consultant/AlbumList').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId',
        lazy: () => import('./pages/Consultant/AlbumDetail').then((m) => ({ Component: m.default })),
      },
      {
        path: 'albums/:albumId/tracks/:trackId',
        lazy: () => import('./pages/Consultant/TrackDetail').then((m) => ({ Component: m.default })),
      },
    ],
  },
])
